import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import LoadingSpinner from '../../components/UI/LoadingSpinner';
import * as authService from '../../services/authService';

export default function VerifyEmail() {
	const { token } = useParams();
	const navigate = useNavigate();
	const [state, setState] = useState({ loading: true, success: false });

	useEffect(() => {
		let mounted = true;
		(async () => {
			try {
				await authService.verifyEmail(token);
				if (mounted) setState({ loading: false, success: true });
			} catch {
				if (mounted) setState({ loading: false, success: false });
			}
		})();
		return () => {
			mounted = false;
		};
	}, [token]);

	if (state.loading) {
		return <LoadingSpinner fullScreen />;
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
			<div className="w-full max-w-md bg-white shadow rounded-lg p-6 text-center">
				{state.success ? (
					<>
						<CheckCircle2 className="w-12 h-12 text-green-600 mx-auto" />
						<h1 className="mt-3 text-2xl font-bold">Email verified</h1>
						<p className="text-gray-600 mt-1">Your email has been successfully verified.</p>
						<button
							className="mt-4 px-4 py-2 bg-primary-600 text-white rounded-md"
							onClick={() => navigate('/login')}
						>
							Go to Login
						</button>
					</>
				) : (
					<>
						<AlertCircle className="w-12 h-12 text-red-600 mx-auto" />
						<h1 className="mt-3 text-2xl font-bold">Verification failed</h1>
						<p className="text-gray-600 mt-1">The verification link may be invalid or expired.</p>
						<button
							className="mt-4 px-4 py-2 bg-primary-600 text-white rounded-md"
							onClick={() => navigate('/login')}
						>
							Go to Login
						</button>
					</>
				)}
			</div>
		</div>
	);
}


